import React, {  useEffect, useState } from "react";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { Box, Typography } from "@material-ui/core";
import { useRecoilValue } from "recoil";
import StarIcon from "@material-ui/icons/Star";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { useCheckinDetailGrid } from "Hooks/checkin/useCheckinDetailGrid";
import { useStyles } from "./styles";
import GridTable from "Components/GridTable";
import CustomColumnMenu from "Components/GridTable/customColumnMenu";
import { isArray } from "lodash";
import { imageGeneration } from "src/utils/emojiMapping";
import { useCheckinConstant } from "Hooks/checkin/useCheckinConstant";
import { Tooltip } from "@mui/material";
import CheckIcon from "Assets/images/check.svg";
import CloseIcon from "Assets/images/close.svg";
import { checkArrayLength } from "src/utils";
import RequestFeedbackAttachments from "./Common/RequestFeedbackAttachments";

const SurveySubGridGroupByPeople = ({ data }) => {
  const classes = useStyles();
  const { surveyDetailsColumns } = useCheckinDetailGrid();
  const { getQuestionType } = useCheckinConstant();
  const [columnsState, setColumnsState] = useState([]);
  const { checkInType } = useRecoilValue(checkinDetailSelector);

  useEffect(() => {
    const columns = surveyDetailsColumns.filter((c) =>
      (checkInType === "SKILLRATING"
        ? ["question", "response"]
        : ["question", "questionType", "response"]
      ).includes(c.field)
    );
    setColumnsState(columns);
  }, []);

  const getText = (type, text) => {
    return type === "EMOJIRANKING" ? (
      <img
        src={imageGeneration(text)}
        alt={text}
        className={classes.emojiImage}
      />
    ) : null;
  };

  const fetchUserColumn = (column, responseData) => {
    let columnObject = { ...column };
    let columnMenu = {
      columnMenu: (props) => (
        <CustomColumnMenu
          {...props}
          columns={columnObject}
          data={responseData}
          onColumnsSubmit={() => {}}
        />
      ),
    };
    switch (column.field) {
      case "question":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: (colProps) => {
            return <td>{colProps?.dataItem?.question}</td>;
          },
        };
        break;
      case "questionType":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: (colProps) => {
            return <td>{colProps?.dataItem?.questionType}</td>;
          },
        };
        break;
      case "response":
        columnObject = {
          ...column,
          minWidth:
            checkInType === "SKILLRATING"
              ? 100
              : checkInType === "REQUESTFEEDBACK"
              ? 380
              : "",
          cell: (colProps) => {
            {
              if (!colProps?.dataItem?.response)
                return (
                  <td>
                    <span>-</span>
                  </td>
                );
              return colProps?.dataItem?.type === "EMOJIRANKING" ? (
                <td>
                  <span>
                    {getText(
                      colProps?.dataItem?.type,
                      colProps?.dataItem?.response
                    )}
                  </span>
                </td>
              ) : colProps?.dataItem?.type === "STARRANKING" ? (
                <>
                  <td>
                    <Box display="flex">
                      {colProps?.dataItem?.response
                        ? Array(
                            parseInt(colProps?.dataItem?.response?.[0])
                          ).fill(<StarIcon className={classes.starIcon} />)
                        : "-"}
                    </Box>
                  </td>
                </>
              ) : (
                <td>
                  <Box display="flex" alignItems="flex-start">
                    {colProps?.dataItem?.answer?.length ? (
                      colProps?.dataItem?.response?.length ? (
                        colProps?.dataItem?.isCorrect ? (
                          <Tooltip title="Correct answer">
                            <img
                              src={CheckIcon}
                              alt="correct"
                              width="8px"
                              className={classes.resIcon}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Incorrect answer">
                            <img
                              src={CloseIcon}
                              alt="incorrect"
                              width="8px"
                              className={classes.resIcon}
                            />
                          </Tooltip>
                        )
                      ) : (
                        "-"
                      )
                    ) : null}
                    {["SURVEY", "REQUESTFEEDBACK", "SKILLRATING"].includes(
                      checkInType
                    ) ? (
                      <>
                        <Tooltip
                          title={
                            <Typography
                              variant="body2"
                              className="font-12 format-txt"
                              dangerouslySetInnerHTML={{
                                __html: colProps?.dataItem?.response,
                              }}
                            ></Typography>
                          }
                        >
                          <Typography
                            variant="body2"
                            className={`font-13 format-txt pre-wrap`}
                            dangerouslySetInnerHTML={{
                              __html: colProps?.dataItem?.response,
                            }}
                          ></Typography>
                        </Tooltip>
                      </>
                    ) : null}
                  </Box>
                  {colProps?.dataItem?.attachments?.length > 0 && (
                    <Box display="flex" mt={2}>
                      <Typography
                        variant="body2"
                        className="font-12 font-semibold mr10"
                      >
                        Attachments
                      </Typography>
                      <RequestFeedbackAttachments
                        attachmentData={colProps?.dataItem?.attachments}
                        isDownload={true}
                      />
                    </Box>
                  )}
                </td>
              );
            }
          },
        };
        break;
      // default:
      //   columnObject = { ...column };
      //   break;
    }

    return <Column {...columnObject} width={columnObject.minWidth} />;
  };
  const userResponseData = (allCheckinData) => {
    const data = [];
    allCheckinData?.surveyCheckin?.map((item, i) => {
      let responses =
        isArray(item?.userAnswer) && item?.userAnswer?.length > 0
          ? item?.userAnswer?.join(", ")
          : "";
      if (
        !["EMOJIRANKING", "STARRANKING", "DESCRIPTIVE"].includes(
          item?.questionType
        )
      ) {
        responses = (
          checkInType === "SKILLRATING"
            ? item?.userAnswer
            : item?.userAnswer
                ?.reduce((res, ele) => {
                  const idx = item?.options?.findIndex(
                    (r) => r.toLowerCase() === ele.toLowerCase()
                  );
                  const ansIdx = item?.answer?.length
                    ? item?.answer?.findIndex(
                        (r) => r.toLowerCase() === ele.toLowerCase()
                      )
                    : 0;

                  res.push(
                    `${
                      ansIdx >= 0 ? "" : '<span class="incorrect-ans d-block">'
                    } ${String.fromCodePoint(65 + idx)}. ${ele} ${
                      ansIdx >= 0 ? "" : "</span>"
                    }`
                  );
                  return res;
                }, [])
                ?.sort()
        )?.join(" \n");
      }

      if (item?.response !== null) {
        data.push({
          isCorrect: item?.isCorrect,
          type: item?.questionType,
          questionType: getQuestionType(item?.questionType)?.value,
          question: `${i + 1}. ${item?.question}`,
          //   fullName: `${item?.user?.firstName} ${item?.user?.lastName}`,
          //   firstName: item?.user?.firstName,
          //   lastName: item?.user?.lastName,
          //   fileName: item?.user?.profileImage?.fileName,
          answer: item?.answer,
          response: responses,
          responseDate: item?.responseDate,
          attachments: item?.reqFeedbackAttachments,
        });
      }
    });
    return data;
  };

  return (
    <Box className={classes.surveySubTable}>
      <GridTable
        data={userResponseData(data)}
        isPageable={true}
        sortable={false}
      >
        {columnsState.map(
          (column) =>
            column.show && fetchUserColumn(column, userResponseData(data))
        )}
      </GridTable>
      <Box>
        <Box>
          {checkArrayLength(data?.comments) ? (
            <Box>
              {data?.comments?.map((res) => {
                return (
                  <Box className={classes.commentBlock} pt={3} px={1.5}>
                    <Typography
                      variant="body2"
                      className="font-13 font-semibold"
                      gutterBottom
                    >
                      Comments
                    </Typography>
                    {/* <UserProfileWidget
                      firstName={res?.rater?.firstName}
                      lastName={res?.rater?.lastName}
                      url={res?.rater?.profileImage?.fileName}
                    /> */}
                    <Typography variant="body2" className="font-13 pre-wrap">
                      {res?.comment || ""}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default SurveySubGridGroupByPeople;
